module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/lodi.9afbc525e4c1ae158d22fbf8f603e12e.jpg";